/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf,
    bool,
    func,
    number,
    object,
    shape,
    string,
} from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import FilterIcon from '../../../../BrandTheme/Icons/FilterSvgIcon';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import GraphqlDesktopProductFacetsV2 from './GraphqlDesktopProductFacetsV2';
import GraphqlMobileProductFacetsV2 from './GraphqlMobileProductFacetsV2';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { FilterDialog } from '../FilterDialog/FilterDialog';

const GraphqlMobileDesktopFacetsV2 = ({
    isFoodBrand,
    classes,
    productFacetsBase,
    isFacetFiltersCountEnabled,
    filterFlag,
    category,
    trackEventAction,
    categoryData,
    abCategorySortAndFilter,
    isFilterFactsV2,
    isFilterFacetsV3,
    featureFlags,
    displayDeliveryMethod,
    setFacetsDataInCollection,
    setFilterDataInCategoryBuilder,
    presentation_family,
    productCount,
}) => {
    // filter sorting dialog
    const filterDialogData = () => (
        category !== null && abCategorySortAndFilter !== 'hide' && (
            <FilterDialog
                cmsFilterFlag={categoryData?.content?.entries?.[0]?.show_filters}
                isFilterFactsV2={isFilterFactsV2}
                isFilterFacetsV3={isFilterFacetsV3}
                filterFlag={filterFlag}
                track={trackEventAction}
                featureFlags={featureFlags}
                displayDeliveryMethod={displayDeliveryMethod}
                setFacetsOptions={setFacetsDataInCollection}
                setFilterOptions={setFilterDataInCategoryBuilder}
                presentation_family={presentation_family}
                brand={categoryData?.brand}
                productFacets={productFacetsBase}
                category={category}
                productCount={productCount}
            />
        )
    );

    // use for Filter SVG icon
    const svgIconData = (classFilter, toggleFilterData, selectedFilters = null) => (
        toggleFilterData ? (
            <>
                <span>Hide Filters </span>
                <CloseIcon className={classFilter.hideFilters} />
            </>
        ) : (
            <>
                <span>Filter{selectedFilters ? ` (${selectedFilters})` : ''}</span>
                <FilterIcon />
            </>
        )
    );
    return (
        <DesktopMobile
            desktop={() => (
                <GraphqlDesktopProductFacetsV2
                    isFoodBrand={isFoodBrand}
                    classes={classes}
                    productFacetsBase={productFacetsBase}
                    isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                    category={category}
                    trackEventAction={trackEventAction}
                    categoryData={categoryData}
                    setFacetsDataInCollection={setFacetsDataInCollection}
                    svgIconData={svgIconData}
                    filterDialogData={filterDialogData}
                />
            )}
            mobile={() => (
                <GraphqlMobileProductFacetsV2
                    isFoodBrand={isFoodBrand}
                    classes={classes}
                    productFacetsBase={productFacetsBase}
                    isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                    category={category}
                    trackEventAction={trackEventAction}
                    categoryData={categoryData}
                    setFacetsDataInCollection={setFacetsDataInCollection}
                    svgIconData={svgIconData}
                    filterDialogData={filterDialogData}
                    abCategorySortAndFilter={abCategorySortAndFilter}
                    displayDeliveryMethod={displayDeliveryMethod}
                    presentation_family={presentation_family}
                    setFilterDataInCategoryBuilder={setFilterDataInCategoryBuilder}
                    isFilterFactsV2={isFilterFactsV2}
                    openDisplayFacets
                />
            )}
        />
    );
};

GraphqlMobileDesktopFacetsV2.propTypes = {
    classes: object.isRequired,
    isFoodBrand: bool.isRequired,
    productFacetsBase: arrayOf(shape({
        name: string,
        entries: arrayOf(shape({
            count: number,
            from: number,
            name: string,
            value: string,
        })),
    })),
    isFacetFiltersCountEnabled: bool.isRequired,
    filterFlag: bool.isRequired,
    category: shape({
        id: string,
        name: string,
        productFacets: arrayOf(shape({
            name: string,
            entries: arrayOf(shape({
                count: number,
                from: number,
                name: string,
                value: string,
            })),
        })),
    }),
    trackEventAction: func,
    categoryData: object.isRequired,
    abCategorySortAndFilter: object.isRequired,
    isFilterFactsV2: bool.isRequired,
    isFilterFacetsV3: bool.isRequired,
    featureFlags: object.isRequired,
    displayDeliveryMethod: object.isRequired,
    setFacetsDataInCollection: func.isRequired,
    setFilterDataInCategoryBuilder: func.isRequired,
    presentation_family: string.isRequired,
    productCount: number,
};

GraphqlMobileDesktopFacetsV2.defaultProps = {
    productFacetsBase: [],
    category: {},
    trackEventAction: () => {},
    productCount: 0,
};
const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});
const enhance = compose(
    withRouter,
    connect(mapStateToProps, null),
);

export default enhance(GraphqlMobileDesktopFacetsV2);
